import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Practices from '../../api/Practices';

import Sidebar from './Sidebar';
import ErrorPractice from '../../components/Practice/ErrorPractice';
import Practice1 from '../../components/Practice/Assurances-et-reparation-du-dommage';
import Practice2 from '../../components/Practice/Circulation-routiere';
import Practice3 from '../../components/Practice/Contrats';
import Practice4 from '../../components/Practice/Copropriete';
import Practice5 from '../../components/Practice/Familial';
import Practice6 from '../../components/Practice/Jeunesse';
import Practice7 from '../../components/Practice/Penal';
import Practice8 from '../../components/Practice/Responsabilite';
import Practice9 from '../../components/Practice/Saisies';

const componentMap = {
	Practice1: Practice1, // Mapping 'Practice1' to Practice1 component
	Practice2: Practice2, // Mapping 'Practice2' to Practice2 component
	Practice3: Practice3, // Mapping 'Practice2' to Practice2 component
	Practice4: Practice4, // Mapping 'Practice2' to Practice2 component
	Practice5: Practice5, // Mapping 'Practice2' to Practice2 component
	Practice6: Practice6, // Mapping 'Practice2' to Practice2 component
	Practice7: Practice7, // Mapping 'Practice2' to Practice2 component
	Practice8: Practice8, // Mapping 'Practice2' to Practice2 component
	Practice9: Practice9, // Mapping 'Practice2' to Practice2 component
	// Add more components here as needed
};

const PracticeDetailPage = props => {
	const { slug } = useParams();

	const PracticeDetails = Practices.find(item => item.slug === slug);

	return (
		<Fragment>
			<Navbar />
			<PageTitle pageTitle={PracticeDetails.sTitle} pagesub={'Matières'} />
			<div className='py-[100px] md:py-[80px]'>
				<div className='wraper'>
					<div className='grid grid-cols-12 gap-3'>
						<Sidebar />

						<div className='col-span-8 md:col-span-12 order-2 md:order-1'>
							{PracticeDetails && componentMap[PracticeDetails.comp]
								? React.createElement(componentMap[PracticeDetails.comp])
								: React.createElement(ErrorPractice)}
						</div>
					</div>
				</div>
			</div>
			<Footer />
			<Scrollbar />
		</Fragment>
	);
};
export default PracticeDetailPage;
